// src/pages/Invoices/Report/SalesItemsDetailReport.jsx
import React from "react";
import ItemsDetailReport, { SALES_DETAIL } from "../../../components/Reports/ItemsDetailReport";

export default function SalesItemsDetailReport() {
  return <ItemsDetailReport config={SALES_DETAIL} />;
}
